import './RainfallTable.css';

export const Cell = ({
  children,
  className = '',
  tooltip,
  rowBg,
}: {
  children: React.ReactNode;
  className?: string;
  tooltip?: string;
  rowBg: string;
}) => (
  <td
    className={className}
    style={{ backgroundColor: rowBg }}
    {...(tooltip ? { 'data-tooltip': tooltip } : {})}
  >
    {children}
  </td>
);
